import http from './http';

export default {
  list() { return http.get('/notifications').then((r) => r.data.data); },
  markRead(id) { return http.put(`/notifications/${id}/read`).then((r) => r.data.data); },
  markAllRead() { return http.put('/notifications/read-all').then((r) => r.data.data); },
};
